/**
 * API base URLs — override via .env when needed:
 *   REACT_APP_MAIN_URL=https://testing.api.erp.nsplprojects.com
 *   REACT_APP_OTHER_LIVE_URL=https://testing.api.erp.nsplprojects.com
 */

const LIVE_URL = "https://testing.api.erp.nsplprojects.com";
const LOCAL_URL = "http://127.0.0.1:8000";

/** Primary API (project-management, metadata, filtered lists) */
export const MAIN_URL = process.env.REACT_APP_MAIN_URL || LIVE_URL;

/** Auth, permissions, datagrid config endpoints */
export const OTHER_LIVE_URL =
  process.env.REACT_APP_OTHER_LIVE_URL || LIVE_URL;

/** Sent on login and API calls so backend scopes org user / permissions to PM */
export const APPLICATION_KEY = "pm";

export function getApiHeaders(extraHeaders = {}) {
  const headers = {
    "Content-Type": "application/json",
    ...extraHeaders,
  };
  const token = localStorage.getItem("token");
  if (token) {
    headers.Authorization = `Bearer ${token}`;
  }
  if (APPLICATION_KEY) {
    headers["X-Application-Key"] = APPLICATION_KEY;
  }
  return headers;
}
